import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Button, Row, Col } from 'react-bootstrap'
import UserService from "../../controllers/UserService";
import AuthService from "../../controllers/AuthService";
import $ from 'jquery'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Helmet from 'react-helmet';


const RFReportStudentList = props => {
    
    const { roomId } = useParams();
    // const currentUser = AuthService.getCurrentUser();
    // const userId = AuthService.getCurrentUser().id;
    const userRole = AuthService.getUserRole();
    let [stdList, setStdList] = useState([]);
 
    useEffect(() => {
        
        try {  
            let filter = {};
           
            UserService.getRiasecStudentInRoom(roomId).then((response) => {
                var tempStd = response.data.data;
                tempStd.sort(function (a, b) { return a['student']['no'] - b['student']['no']; });
                setStdList(tempStd);
                setStdList(response.data.data);
            }).then(() => { 
                
            })
           
        } catch (error) {

        }
        
    }, []);
    

    function selectionChange(){   
        var temp = $('#search').val();
        // var count1 = 1;
      
        $('.div-detail').each(function(i, obj) {  
            let studentName = obj.querySelector('.student-name').innerHTML + obj.querySelector('.student-no').innerHTML;           
            var checkStatus = studentName.includes(temp);

            if(
                (checkStatus) 
            ){
                $(obj).show();
               
            } else {
                $(obj).hide();
            }
        });
    }


    return (
        <div className="mb-5 riasec-report">
            <Helmet>
                <title>รายงานแบบประเมิน - Mindsetmaker.co</title>
                <meta property="og:title"       content={`รายงานแบบประเมิน RIASEC - Mindsetmaker.co`} />
                <meta property="og:description" content={`รายงานแบบประเมิน RIASEC`} />
            </Helmet>
            <div className="px-4 main-detail">
               
                <Row className="px-0 pt-5" >                        
                        <Col xs={12} className="w-100 pb-3 px-0">
                            <div className="w-100 px-0" id="search-div">
                                <FontAwesomeIcon icon={faSearch} className="gray-text3 icon-search"></FontAwesomeIcon>
                                <input className="form-control form-control-sm w-100 border-radius-5 search" type="text" id="search" placeholder="ค้นหา ชื่อ-นามสกุล หรือเลขที่" onInput={() => selectionChange()} />
                            </div>
                        </Col>                            
                </Row>
                <Row className="blue-bg py-2 mt-3">
                    <Col xs={2} md={2} className="text-center pr-0 gray-text3 font-sarabun-bold">เลขที่</Col>
                    <Col xs={6} md={8} className="text-center gray-text3 font-sarabun-bold"><span className="pr-md-5 mr-md-5">ชื่อ - นามสกุล</span><span className="pr-md-5 mr-md-5"></span><span className="pr-md-5 mr-md-5"></span></Col>                 
                    <Col xs={4} md={2} className="text-center px-0 gray-text3 font-sarabun-bold" style={{"position": "relative"}}></Col>
                </Row>
                {
                        (stdList) ? (
                            stdList.map((item, index) => (  
                                <Row key={index.toString()} className={`border-bottom-blue py-3 div-detail font-sarabun-bold `}> 
                                    <Col xs={2} md={2} className="text-center my-1"><h5 className="mb-0 font-weight-600 order student-no">{item.student.no}</h5></Col>
                                    <Col xs={6} md={8} className="text-left my-1">
                                        <p className="student-name m-0">{item.student.fullName}</p>
                                        {/* <p className="t-12 m-0"><a href={`/report/riasec/${roomId}/${item.student.id}`} className="text-green-evaluate"><u>ผลการประเมิน</u></a></p> */}
                                        <p className={`t-10 m-0 position-relative teacher-${item.doneByTeacher} student-${item.doneByStudent} parent-${item.doneByParent}`}><span className="t-20 position-absolute " style={{"color": "#F7B31D", "top": "-8px"}}>&#8226;</span> <span className="pl-2">ประเมินยังไม่ครบ</span></p>
                                    </Col>
                                    <Col xs={4} md={2} className="text-center my-1"><a href={`/report/riasec/${roomId}/${item.student.id}`}><Button className="bg-lightness4-blue  border-0px click-pointer btn font-sarabun-bold t-12 btn font-sarabun-bold text--black">ผลประเมิน</Button></a></Col>
                                </Row>
                                ))
                            ) : (
                                <div></div>
                            )
                }
            </div>
        </div>
    )
}


export default RFReportStudentList